import React, { lazy } from 'react';
export function SolutionSection() {
  return <section className="bg-teal py-20 px-4 relative overflow-hidden" data-id="element-168">
      <div className="absolute top-0 right-0 w-48 h-48 bg-gold/5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-169" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-170" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-171">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white mb-12" data-id="element-172">
          "Presentando El Acelerador 24H: El Sistema Completo Para Adelgazar Con
          Tu Airfryer Sin Complicaciones"
        </h2>

        {/* Mockup - REAL IMAGE */}
        <div className="relative max-w-3xl mx-auto mb-12" data-id="element-173">
          <img src="https://cdn.magicpatterns.com/uploads/ge6ddC3LbijriWmfqvSKgP/EL_ACELERADOR_24H.jpg" alt="El Acelerador 24H — Pack Completo: 5 Tomos + 3 Bonos" className="w-full h-auto rounded-2xl shadow-2xl" width={848} height={1264} loading="lazy" decoding="async" data-id="element-174" />
        </div>

        <div className="text-lg md:text-xl text-white/90 leading-relaxed space-y-6 max-w-3xl mx-auto text-left bg-white/10 backdrop-blur-sm p-8 rounded-3xl border border-white/10" data-id="element-175">
          <p data-id="element-176">El Acelerador 24H no es un recetario más.</p>
          <p data-id="element-177">
            Es un{' '}
            <span className="font-bold text-gold" data-id="element-178">
              sistema de 5 tomos + 3 bonos
            </span>{' '}
            diseñado por una nutricionista clínica para que pierdas entre 3 y
            6kg el primer mes con exactamente 10 minutos de cocina al día.
          </p>
          <p data-id="element-179">
            Sin contar calorías. Sin pesarte los alimentos. Sin recetas de 20
            ingredientes.
          </p>
          <p className="font-semibold text-gold" data-id="element-180">
            Solo abres el tomo del día, coges 3 ingredientes y en 10 minutos
            tienes una cena proteica, saludable y que realmente está buena.
          </p>
        </div>
      </div>
    </section>;
}